// extracted by mini-css-extract-plugin
export default {"root":"TariffList__root--RiXMX"};